// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__AG7qD","sections":"style_sections__1FWwX"};